angular.module('qbePortal').controller('PolicyStartDateController', [
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'$window',
	'userInputRepository',
	'serviceResponseRepository',
	'dynamicRouter',
	'labelService',
	'Util',
	'$q',
	'storage',
	'gtmService',
	function ($rootScope, $scope, $state, $stateParams, $window, userInputRepository, serviceResponseRepository, dynamicRouter, labelService, util, $q, storage, gtmService) {
		var $ctrl = this;
		$ctrl.validationErrors = null;
		$ctrl.sections = {};
		$ctrl.state = $state;
		$ctrl.storage = storage;		

		$scope.$root.$broadcast('loading-animation-end');

		$ctrl.registerSection = function (name, init, getValueFn) {
			$ctrl.sections[name] = {
				initValue: init,
				getValue: getValueFn
			};
		}

		function markCompletedRouteCallback(stateName) {
			storage.setItem('completed-step', stateName);
		}

		function initialiseRouting() {
			var isRetrieve = storage.getItem('policy-date-input');
			if (angular.equals(isRetrieve, {})) // check 
				dynamicRouter.initialise($ctrl.state.current.name, $ctrl.state.$current.parent.name, null, markCompletedRouteCallback);
		}

		$ctrl.initPolicyStartDatePage = function () {
			initialiseRouting();
			util.dispatchCustomEvent('register-labels');
			$ctrl.formData = getUserInput();
		}

		$ctrl.submit = function (form) {

			//gtmService.trackEvent('next');
			$ctrl.showErrorSummary = false;
			if (form.$invalid) {
				$scope.$broadcast('broadcast-field-errors');
				$ctrl.showErrorSummary = true;
				$scope.$broadcast('reset-field-errors');
				scrollViewTo($('#combinedValidationListing'));
				return;
			}
			var formData = getUserInput();
			$ctrl.formData = formData;
			var product = $state.$current.parent.name + 'Form';
			var input = storage.getItem('policy-date-input');	
			if(product !== 'homeForm'){		
				input[product].getStarted.policyStartDate = $ctrl.formData.pastPolicyStartDateForm.pastPolicyStartDateDetails.policyStartDate;				
			}				
			else{
				input[product].letsGetStarted.startCoverDate = $ctrl.formData.pastPolicyStartDateForm.pastPolicyStartDateDetails.policyStartDate;				
				storage.setItem('completed-step', dynamicRouter.getState(0));
			}		
			userInputRepository.update(input);				
			storage.removeItem('policy-date-input');						
			moveToState($state.$current.parent.name);
		}

		function moveToState(stateParent) {
			if(stateParent !== 'home')
				$state.go(dynamicRouter.getState(0));
			else {
				$state.go(dynamicRouter.getState(1));
			}	
		}

		function getUserInput() {
			var formData = getFormInput();
			userInputRepository.update(formData);
			return userInputRepository.get(getDefaultValues());
		}

		function getFormInput() {
			var formData = {};
			for (var key in $ctrl.sections) {
				formData[key] = $ctrl.sections[key].getValue();
			}
			return formData;
		}

		function getDefaultValues() {
			var defaultValues = {
				pastPolicyStartDateForm: {
					pastPolicyStartDateDetails: {
						policyStartDate: moment().tz("Australia/Sydney").format('DD/MM/YYYY'),
					}
				},
			};
			return defaultValues;
		}

		function scrollViewTo($element) {
			var offset = $element.offset();
			if ( offset ) {
				$('html, body').animate({
					scrollTop: (offset.top - 50),
					scrollLeft: offset.left
				});
			}
		}

		
	}
]);
